import { AspectRatioBox, AspectRatioBoxBody } from 'baseui/aspect-ratio-box';
import { Cell, Grid } from 'baseui/layout-grid';
import { h } from 'preact';
import { useCallback, useState } from 'preact/hooks';
import { Route, useLocation } from 'wouter-preact';

import AnimatedRouter from './AnimatedRouter';
import PreferencesForm, { Preferences } from './PreferencesForm';
import CoffeeMap from './map/CoffeeMap';
import PointsOfInterestProvider from './map/PointsOfInterestProvider';
import SearchResults from './SearchResults';

export default function RoutePlanner() {
    const [preferences, setPreferences] = useState<Preferences | null>(null);
    const [, navigate] = useLocation();
    const onRestart = useCallback(() => {
        setPreferences(null);
        navigate('/');
    }, [navigate]);
    const onSubmit = useCallback(($e: FormData) => {
        setPreferences(Object.fromEntries($e.entries()) as Preferences);
        navigate('/hop');
    }, [navigate]);

    return (
        <PointsOfInterestProvider>
            <Grid overrides={{
                Grid: {
                    style: {
                        alignItems: 'stretch',
                        flexWrap: 'wrap-reverse',
                        paddingBottom: '36px',
                        paddingTop: '36px',
                        rowGap: '36px',
                    },
                },
            }}>
                <Cell span={[4, 4, 6]}>
                    <AnimatedRouter classNames="fade" timeout={400}>
                        <Route path="/">{() => <PreferencesForm onSubmit={onSubmit} />}</Route>
                        <Route path="/hop">{() => <SearchResults preferences={preferences}
                                                                 onRestart={onRestart} />}</Route>
                    </AnimatedRouter>
                </Cell>
                <Cell span={[4, 4, 6]}>
                    <AspectRatioBox>
                        <AspectRatioBoxBody>
                            <CoffeeMap interactive={preferences === null} />
                        </AspectRatioBoxBody>
                    </AspectRatioBox>
                </Cell>
            </Grid>
        </PointsOfInterestProvider>
    );
}
